import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import React from 'react';
import { useSelector } from 'react-redux';
import {ReactComponent as Light} from '../../../assets/new-icons/light.svg';
import {ReactComponent as Gas} from '../../../assets/new-icons/gas.svg';

function ListaPods({setHandleDetailPod, setStatePod}) {
    const addressList = useSelector((user) => user?.user?.podsList)

    const handlePod = (item) => {
        setHandleDetailPod(true)
        setStatePod(item)
    }
    function isGasForniture(pod) {
        return pod.customerId > 200000;
    }

    return (
        <div className="listPods">
            {addressList && addressList.map((item, i) => (
                <div className="item" key={i} onClick={() => handlePod(item)}>
                    <div className="icon">
                        {isGasForniture(item) ? <Gas /> : <Light />}
                    </div>
                    <div className="info">
                        <p className="main">{item.podName || item.podCode}</p>
                        <p className="secondary">{item.podAddress}</p>
                    </div>
                    <div className="arrow">
                        <ArrowForwardIos />
                    </div>
                </div>
            ))}
        </div>
    );
}

export default ListaPods;
